import styles from './Footer.module.css'

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<div className={styles.footer}>
			<div>
				Copyright ©{currentYear} Giverist. All Rights Reserved.
			</div>
			<div className={styles.links}>
				<a className={styles.link} href="/terms" target="_blank">
					Terms
				</a>
				|
				<a className={styles.link} href="/guidelines" target="_blank">
					Guidelines
				</a>
				|
				<a className={styles.link} href="/privacy" target="_blank">
					Privacy
				</a>
			</div>
		</div>
	)
};

export default Footer;